import axiosClient from "../../Services/axiosClient";
import errorMsg from "../../Services/errorMsg";

import { addAlert } from "../Alerts/Alerts";

const postData = async (new_data, URL_CREATE, changeLoadingState, success) => {
  await axiosClient
    .post(URL_CREATE, new_data)
    .then((res) => {
      addAlert();
      if (success) success();
    })
    .catch((error) => {
      errorMsg(error);
    });
  if (changeLoadingState) changeLoadingState(false);
};

export default postData;
